import { PlacesListAdminView } from "place/admin/views/PlacesListAdminView";
import { Route, Routes } from "react-router-dom";
import { PlaceAdminView } from "place/admin/views/PlaceAdminView";
export function PlaceAdminRoutes() {
  return (
    <Routes>
      <Route path="" element={<PlacesListAdminView />} />
      <Route path="new" element={<PlaceAdminView isCreateMode={true} />} />
      <Route path=":placeId">
        <Route path="" element={<PlaceAdminView isCreateMode={false} />} />
      </Route>
      <Route path=":placeId/duplicate">
        <Route path="" element={<PlaceAdminView isCreateMode={false} />} />
      </Route>
    </Routes>
  );
}
